import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { MainSidebar } from "../../components/sidebars/MainSidebar";
import { DEFAULT_TWD_PER_USD } from "../../lib/utils/aiCost";
import { AI_USAGE_GROUPS, type AiUsageFilters, AiUsagePage } from "./-AiUsagePage";

const aiUsageSearchSchema = z.object({
  groupBy: z.enum(AI_USAGE_GROUPS).optional().default("lesson"),
  days: z.number().optional().default(7),
  rate: z.number().positive().optional().default(DEFAULT_TWD_PER_USD),
  lesson: z.string().optional(),
  editor: z.string().optional(),
  template: z.string().optional(),
  batch: z.string().optional(),
  job: z.string().optional(),
});

function AiUsageRoute() {
  const filters = useSearch({ from: "/admin/ai-usage" });
  const navigate = useNavigate();

  const onFiltersChange = (next: Partial<AiUsageFilters>) => {
    void navigate({ to: "/admin/ai-usage", search: { ...filters, ...next } });
  };

  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 overflow-auto">
        <AiUsagePage filters={filters} onFiltersChange={onFiltersChange} />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/admin/ai-usage")({
  validateSearch: aiUsageSearchSchema,
  component: AiUsageRoute,
});
